module.exports = __webpack_public_path__ + "static/img/banner2.9a7db4ae.jpg";